const tools = [
  {
    description: "Android: USB terminal for Arduino and serial devices.",
    link: "https://play.google.com/store/apps/details?id=org.kabiri.android.usbterminal",
    label: "USB Terminal"
  },
  {
    description: "Android: Detect unknown WLAN users",
    link: "https://play.google.com/store/apps/details?id=com.superus8r.android.wlanwatchdog",
    label: "WLAN Watchdog"
  },
  {
    description: "Android: NetAlertX Companion",
    link: "https://play.google.com/store/apps/details?id=com.superus8r.android.netalertxcompanion",
    label: "Your NetAlertX Android Companion"
  },
  {
    description: "Compare two texts line‑by‑line and highlight changes.",
    link: "/apps/diff",
    label: "Diff"
  },
  {
    description: "Convert input to plain, cleaned text.",
    link: "/apps/plain-text",
    label: "Plain Text"
  },
  {
    description: "Generate and test clickable mobile app deeplinks.",
    link: "/apps/deeplink",
    label: "Deeplink"
  },
  {
    description: "Prettify, edit and validate JSON side‑by‑side.",
    link: "/apps/json-prettifier",
    label: "JSON"
  },
  {
    description: "Web: Live wait times for theme-park rides.",
    link: "https://waitland.vercel.app/",
    label: "Waitland"
  }
];

export default tools;
